import Vue from "vue";
import PullToRefresh from "./Shared/PullToRefresh.vue";
const Loader = () => import("./Shared/Loader.vue");
const Button = () => import("./Shared/Button.vue");
const ButtonV2 = () => import("./Shared/ButtonV2.vue");
const BottomSheet = () => import("./Shared/BottomSheet.vue");
const BottomSheetBetslip = () => import("./Shared/BottomSheetBetslip.vue");
const Input = () => import("./Shared/Input.vue");
const Select = () => import("./Shared/Select.vue");
const SelectV2 = () => import("./Shared/SelectV2.vue");
const TextArea = () => import("./Shared/TextArea.vue");
const Checkbox = () => import("./Shared/Checkbox.vue");
const CheckBoxGroup = () => import("./Shared/CheckBoxGroup.vue");
const PageError = () => import("./Shared/PageError.vue");
const Accordion = () => import("./Shared/Accordion.vue");
const BError = () => import("./Shared/Error.vue");
const Spinner = () => import("./Shared/Spinner.vue");
const SportIcon = () => import("./Shared/SportIcon.vue");
const Modal = () => import("./Shared/Modal.vue");
const Fullscreen = () => import("./Shared/Fullscreen.vue");

const GoBack = () => import("./Shared/GoBack.vue");
const Back = () => import("./Shared/Back.vue");
const Empty = () => import("./Shared/Empty.vue");
const Logo = () => import("./Shared/Logo.vue");
const Marker = () => import("./Shared/Marker.vue");
const Popup = () => import("./Shared/Popup.vue");
const Toast = () => import("./Shared/Toast.vue");
const ConfirmDialogue = () => import("./Shared/ConfirmDialogue.vue");
const NotificationWidget = () => import("./Shared/NotificationWidget.vue");

/**
 * Register components to Vue object
 */
Vue.component("modal", Modal);
Vue.component("fullscreen", Fullscreen);
Vue.component("loader", Loader);
Vue.component("spinner", Spinner);
Vue.component("back", Back);
Vue.component("go-back", GoBack);
Vue.component("empty", Empty);
Vue.component("b-marker", Marker);
Vue.component("pull-to-refresh", PullToRefresh);
Vue.component("page-error", PageError);
Vue.component("error", BError);
Vue.component("logo", Logo);
Vue.component("b-button", Button);
Vue.component("b-button-ii", ButtonV2);
Vue.component("b-input", Input);
Vue.component("b-select", Select);
Vue.component("b-select-ii", SelectV2);
Vue.component("b-textarea", TextArea);
Vue.component("b-checkbox", Checkbox);
Vue.component("b-checkbox-group", CheckBoxGroup);
Vue.component("accordion", Accordion);
Vue.component("bottom-sheet", BottomSheet);
Vue.component("sport-icon", SportIcon);
Vue.component("b-popup", Popup);
Vue.component("toast", Toast);
Vue.component("notification-widget", NotificationWidget);
Vue.component("confirm-dialogue", ConfirmDialogue);
const RegisterComponents = () => {
	return new Promise((resolve, reject) => {
		Vue.component("modal", Modal);
		Vue.component("fullscreen", Fullscreen);
		Vue.component("loader", Loader);
		Vue.component("spinner", Spinner);
		Vue.component("back", Back);
		Vue.component("empty", Empty);
		Vue.component("b-marker", Marker);
		Vue.component("pull-to-refresh", PullToRefresh);
		Vue.component("page-error", PageError);
		Vue.component("error", BError);
		Vue.component("logo", Logo);
		Vue.component("b-button", Button);
		Vue.component("b-button-ii", ButtonV2);
		Vue.component("b-input", Input);
		Vue.component("b-select", Select);
		Vue.component("b-textarea", TextArea);
		Vue.component("b-checkbox", Checkbox);
		Vue.component("b-checkbox-group", CheckBoxGroup);
		Vue.component("accordion", Accordion);
		Vue.component("bottom-sheet", BottomSheet);
		Vue.component("bottom-sheet-betslip", BottomSheetBetslip);
		Vue.component("sport-icon", SportIcon);
		Vue.component("b-popup", Popup);
		Vue.component("confirm-dialogue", ConfirmDialogue);
		Vue.component("go-back", GoBack);
		resolve(true);
	});
};

export { RegisterComponents };
